/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";

// MUI
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";

// Icons
import InfoIcon from '@mui/icons-material/Info';
import RouteAddIcon from "@/icons/RouteAddIcon";

// Types
import { DCRecord } from "@/@types/lib/dataController";

type PublicSearchPaneItemsType =
  {
    items: DCRecord[],
    onClick: (evt: React.MouseEvent<HTMLDivElement>, item: DCRecord) => void
    onAddToRoute: (evt: React.MouseEvent<HTMLButtonElement>, item: DCRecord) => void
    canAddToRoute?: boolean,
    selectedId?: number,
    itemIcon: React.ReactElement,
    primaryTextFn: (item: DCRecord) => string | null,
    secondaryTextFn: (item: DCRecord) => string | null
    handleOpenObilaznica?: (obilaznicaId: number, poi_id: number) => void;
  }

function PublicSearchPaneItems(props: PublicSearchPaneItemsType) {
  const { items, selectedId, onClick, onAddToRoute, itemIcon, canAddToRoute, primaryTextFn, secondaryTextFn, handleOpenObilaznica } = props;

  return (
    <>
      {Array.isArray(items) ? items.map((item, i) => {

        const selected = selectedId === item.id as number;

        const primaryText = primaryTextFn(item);
        const secondaryText = secondaryTextFn(item);

        return (
          <ListItem key={`item-${item.id}`}>
            <ListItemButton dense disableGutters onClick={(evt) => onClick(evt, item)} selected={selected}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'transparent' }}>
                  {itemIcon}
                </Avatar>
              </ListItemAvatar>
              {
                primaryText && primaryText !== null && secondaryText && secondaryText !== null && primaryText.toUpperCase() !== secondaryText.toUpperCase() ?
                  <ListItemText
                    primary={primaryText}
                    secondary={secondaryText} /> :
                  <ListItemText
                    primary={primaryText} />
              }
              {canAddToRoute && selected ? (
                <ListItemSecondaryAction>
                  <IconButton aria-label="add-to-route" onClick={(evt) => onAddToRoute(evt, item)}><RouteAddIcon transform="scale(1.47)" /></IconButton>
                </ListItemSecondaryAction>
              ) : null}
              {!canAddToRoute && handleOpenObilaznica && item.id && selected ? (
                <ListItemSecondaryAction>
                  <IconButton aria-label="add-to-route" onClick={(evt) => handleOpenObilaznica(item.id as number, 0)}><InfoIcon color="primary" /></IconButton>
                </ListItemSecondaryAction>
              ) : null}
            </ListItemButton>
          </ListItem>
        );
      }) : null
      }
    </>);
}

export default PublicSearchPaneItems;
